import {
  Component,
  Input
} from "@angular/core";
import { IModel } from "maps-angular-components";
import { ChipList, IAutocompleteSchema } from "../autocomplete.schema";

/** @title Form field with custom telephone number input control. */
@Component({
  selector: 'lib-chip-autocomplete',
  templateUrl: 'chip-autocomplete.component.html',
})
export class ChipAutocompleteComponent<T extends IModel> {
  public valor: any;

  @Input() schema: IAutocompleteSchema<T>;
  @Input() value: ChipList<T>;

  public getPanelClasses(): string {
    let classes = [];

    if (!this.schema.panelClass) {
      return;
    }

    if (typeof this.schema.panelClass === "string") {
      classes.push(this.schema.panelClass);
    } else {
      classes = this.schema.panelClass;
    }

    return classes.join(" ");
  }

  public convert(value: any) {
    return this.deepCopy(value);
  }

  public deepCopy(obj: any): any {
    var copy;
    if (null == obj || 'object' != typeof obj) return obj;
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepCopy(obj[i]);
      }
      return copy;
    }
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
      }
      return copy;
    }
    throw new Error('Impossível copiar objeto. Tipo não suportado');
  }
}

